import { weekStart } from './habits';
import { addDays, type LocalDate } from './time';

/**
 * LA RACHA DEL RITUAL. Días seguidos con el ritual sellado hasta hoy. Hoy sin sellar
 * todavía no la rompe: el día no ha terminado, y una racha que se apaga a las 7:00
 * porque aún no has abierto la app es un reproche, no un dato.
 */
export function ritualStreak(sealedDates: readonly LocalDate[], today: LocalDate): number {
  const dias = new Set(sealedDates);
  let cursor = dias.has(today) ? today : addDays(today, -1);
  let racha = 0;
  while (dias.has(cursor)) {
    racha += 1;
    cursor = addDays(cursor, -1);
  }
  return racha;
}

/** Los siete días, de lunes a domingo, de la semana que contiene `localDate`. */
export function diasDeLaSemana(localDate: LocalDate): LocalDate[] {
  const lunes = weekStart(localDate);
  return Array.from({ length: 7 }, (_, i) => addDays(lunes, i));
}
